import { useEffect, useState, type CSSProperties, type ReactNode } from "react";
import { useAppEnvironment } from "../telegram";
import { usePreferences } from "./preferences";

export function MechanicTheme({ children }: { children: ReactNode }) {
  const { colorScheme, viewportHeight, insets, theme } = useAppEnvironment();
  const preferences = usePreferences();
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  useEffect(() => {
    const viewport = window.visualViewport;
    const sync = () => setKeyboardHeight(viewport && window.innerHeight - viewport.height > 100 ? viewport.height : 0);
    viewport?.addEventListener("resize", sync);
    sync();
    return () => viewport?.removeEventListener("resize", sync);
  }, []);
  const style = {
    "--app-viewport-height": keyboardHeight || viewportHeight ? `${keyboardHeight || viewportHeight}px` : "100dvh",
    ...Object.fromEntries(Object.entries(insets).map(([side, size]) => [`--app-safe-${side}`, `${size}px`])),
    ...(preferences.theme === "system" ? {
    "--color-background": theme.bg_color,
    "--color-surface": theme.section_bg_color ?? theme.secondary_bg_color,
    "--color-elevated": theme.secondary_bg_color,
    "--color-foreground": theme.text_color,
    "--color-muted": theme.hint_color,
    "--color-primary": theme.button_color,
    "--color-primary-foreground": theme.button_text_color,
    "--color-danger": theme.destructive_text_color,
    } : {}),
  } as CSSProperties;
  return <div className="mechanic-area" lang={preferences.language} data-keyboard={keyboardHeight ? "open" : "closed"} data-theme={preferences.theme === "system" ? colorScheme : preferences.theme} style={style}>{children}</div>;
}
